import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {ConfigItemGroup as _ConfigItemGroup} from 'app-ui-componentlibrary/dist/componentLibrary/layout/ConfigItemGroup';
import contentMap from 'componentLibrary';

export const ConfigItemGroup = (props) => (
  <_ConfigItemGroup {...props} {...{contentMap}} />
);
export const DynamicItemGroup = connectWithCore(ConfigItemGroup);
export default DynamicItemGroup;
